import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import LoadingMainPage from "./Common/Loading/LoadingMainPage";
import { ClientContext } from "./Context/Context";

const PublicRoute = ({ children }) => {
  const { clientIsLoggedIn, clientIsLoading } = useContext(ClientContext);
  console.log(clientIsLoggedIn, clientIsLoading);

  if (clientIsLoading) {
    return <LoadingMainPage isLoading={clientIsLoading} />;
  }

  if (clientIsLoggedIn) {
    console.log("Cliente logeado");
    // return <Navigate to="/panel" replace />;
  } else {
    console.log("No esta logeado");
  }

  // Si hay children (ej: Layout), renderízalos
  if (children) return children;

  // Si no hay children, renderiza Outlet para que se muestren las rutas hijas
  return <Outlet />;
};

export default PublicRoute;
